import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import PanelTemplate from "../../../shares/PanelTemplate";
import MuiButton from "../../../shares/MuiButton";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import PanelTable from "../../../shares/PanelTable";
import AddBrand from "./AddBrand";
import EditBrand from "./EditBrand";
import RemoveBrand from "./RemoveBrand";
import { EmptyData } from "../../../../utils";

const headersList = [
  { colName: "name", name: "نام برند" },
  { colName: "edit", name: "ویرایش" },
  { colName: "remove", name: "حذف" },
];
const mobileHeadersList = [{ colName: "name", name: "نام برند" }];

const dataKey = ["name"];

// import Others files
const Brand = (props) => {
  let windowWidth = window.screen.width;

  const [openAddBrandModal, setOpenAddBrandModal] = useState(false);
  const handleAddBrandModal = () => {
    setOpenAddBrandModal((before) => !before);
  };

  const [isFilterOn, setIsFilterOn] = useState(false);
  const [nameFilter, setNameFilter] = useState(null);

  const [brandsList, setBrandsList] = useState({ results: [] });

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    params: { name: nameFilter },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setBrandsList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  // Filter
  const filterList = [
    {
      type: "textField",
      label_fa: "نام",
      label_en: "name",
      state: nameFilter,
    },
  ];
  // Table
  const buttonsList = [
    {
      label: "ویرایش",
      component: (it) => (
        <EditBrand selectedRow={it} getBrandsApi={getBrandsApi} />
      ),
    },
  ];
  const actionsList = [
    {
      label: "حذف",
      component: (it) => (
        <RemoveBrand selectedRow={it} getBrandsApi={getBrandsApi} />
      ),
    },
  ];

  const update_filter = (state, e) => {
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (nameFilter !== null) {
      setIsFilterOn(true);
      getBrandsApi.reFetch();
    }
  };

  const reset_filter = () => {
    setNameFilter(null);
    getBrandsApi.reFetch();
  };
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setBrandsList({ results: [] });

    getBrandsApi.reFetch();
  };
  return (
    <>
      <PanelTemplate sidebarActiveLink="brands">
        <>
          <div className="panel-main-header">
            <span>مدیریت برندها</span>
          </div>
          <div className="add-item-container">
            <span className="text">
              برای اضافه کردن برند جدید روی دکمه افزودن کلیک کنید.
            </span>
            <MuiButton
              onClick={handleAddBrandModal}
              variant="outlined"
              icon={<AddIcon />}
              color="secondary"
              text="افزودن"
            />
          </div>
          {openAddBrandModal && (
            <AddBrand
              openModal={openAddBrandModal}
              setOpenModal={setOpenAddBrandModal}
              getFunc={getBrandsApi}
            />
          )}
          <PanelFilter
            header="فیلتر برندها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <PanelTable
            header="لیست برندها:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={brandsList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AccountBalanceIcon />}
          />

          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default Brand;
